import React, { Component } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import * as _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import UnitCard from './UnitCard/UnitCard';
import NewUnitCard from './NewUnitCard';
import DragAndDropContainer from '../common/DragAndDropContainer';
import * as bookService from '../../services/domain/bookService';
import { ROLE, DRAWER_CONTENTS } from '../../const';
import * as bookActions from '../../actions/bookActions';
import * as drawerActions from '../../actions/drawerActions';
import AssignmentsCardPlaceholder from '../assignments/AssignmentsCardPlaceholder';

class BookUnitsContainer extends Component {
  isDraggable = () => {
    const { openNewUnit, openUnit, role, isComplete, isAppOnline } = this.props;
    return [ROLE.INSTRUCTOR].includes(role) && openUnit === -1 && openNewUnit === -1 && isAppOnline && isComplete;
  };

  isActive = () => {
    const { openUnit } = this.props;
    return openUnit === -1;
  };

  handlerAfterMoveCard = newUnitsOrder => {
    const { bookActions, classroomId, book } = this.props;

    if (!_.isEqual(book.content, newUnitsOrder) && newUnitsOrder.length > 1) {
      book.content = newUnitsOrder;
      bookActions.updateBookStructure(classroomId, book.id, book.activityId, newUnitsOrder);
    }
  };

  openNewUnitDrawer = () => {
    this.props.drawerActions.openDrawerAndSetContent(DRAWER_CONTENTS.UNIT_CREATE);
  };

  renderCard = card => {
    const { classroomId, book, isComplete, isPreview, unitId } = this.props;
    const { data, isDragging, item, key, order } = card;

    const cardDimensions = this.cardDimensions();
    if (!card || !item) return;

    const position = order.indexOf(key);
    const jailedView = !unitId;

    const newUnitLastPosition =
      position === 0 && jailedView ? (
        <NewUnitCard
          isComplete={this.areNewUnitsComplete()}
          position={position}
          idBook={book.id}
          idClassroom={classroomId}
          onClick={this.openNewUnitDrawer}
        />
      ) : (
        ''
      );

    return (
      <div className="unit-card-wrapper">
        {newUnitLastPosition}
        <UnitCard
          isNotCloseable={!!unitId}
          id={key}
          key={key}
          idBook={book.id}
          idClassroom={classroomId}
          unit={item}
          parentId={data.book.activityId}
          isComplete={isComplete}
          isPreview={isPreview}
          units={data.book.content}
          isDraggable={isDragging}
          width={cardDimensions.width}
          order={order}
          // isEncapsulated={unitId}
          creatingUnit={this.props.creatingUnit}
        />
      </div>
    );
  };

  areNewUnitsComplete = () => this.props.isComplete && this.props.authoring;

  cardDimensions = () => {
    const { book } = this.props;

    const bookActivityId = bookService.removeNotAllowedCharactersToActivityId(book.activityId);
    let bookContainer = `#bookDragAndDropContainer${bookActivityId}`;
    let width = $(bookContainer).width();

    return { width: width, height: 60 };
  };

  render() {
    const { book, unitId, classroomId, isFetchingPreview } = this.props;

    if (isFetchingPreview) return <AssignmentsCardPlaceholder />;
    if (!book.content) return <div />;

    const jailedView = !unitId;

    if (!book.content.length && jailedView) {
      return (
        <NewUnitCard
          isComplete={this.areNewUnitsComplete()}
          position={1}
          idBook={book.id}
          idClassroom={classroomId}
          onClick={this.openNewUnitDrawer}
        />
      );
    }

    const cards = unitId ? book.content.filter(unit => unit.activityId === unitId) : book.content;

    const bookActivityId = bookService.removeNotAllowedCharactersToActivityId(book.activityId);
    const dragActivated = this.isDraggable();

    return (
      <DragAndDropContainer
        cardId="activityId"
        cards={cards}
        rotation={0}
        id={`bookDragAndDropContainer${bookActivityId}`}
        containerClassName=""
        renderCard={this.renderCard}
        handlerAfterMoveCard={this.handlerAfterMoveCard}
        dragActivated={dragActivated}
        active={this.isActive()}
        data={{ book }}
        cardDimensions={this.cardDimensions}
        axisXActivated={false}
      />
    );
  }
}

const mapStateToProps = state => ({
  role: state.classrooms.selectedClassroom.classroom.role,
  classroomId: state.classrooms.selectedClassroom.classroom
    ? state.classrooms.selectedClassroom.classroom.id
    : undefined,
  openNewUnit: state.book.openNewUnit,
  openUnit: state.book.openUnit,
  isAppOnline: state.connection.status.online,
  authoring: state.account.configuration.authoring,
  isFetchingPreview: state.library.isFetchingPreview
});

const mapDispatchToProps = dispatch => ({
  bookActions: bindActionCreators(bookActions, dispatch),
  drawerActions: bindActionCreators(drawerActions, dispatch),
  dispatch
});

BookUnitsContainer.propTypes = {
  book: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isPreview: PropTypes.bool,
  role: PropTypes.string,
  classroomId: PropTypes.string,
  bookActions: PropTypes.object,
  unitId: PropTypes.string,
  authoring: PropTypes.any,
  isAppOnline: PropTypes.any,
  openUnit: PropTypes.any,
  openNewUnit: PropTypes.number,
  isFetchingPreview: PropTypes.bool,
  creatingUnit: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(BookUnitsContainer);
